import Service from './Service'
import PersonalAccessTokens from './PersonalAccessTokens'

/**
 * Authentication API service.
 *
 * @author Alejandro Sanchez <asanchez@claruscare.com>
 */
export default class Auth extends Service {
	/**
	 * The container bindings to inject.
	 * Uses AuthRequest instead of the standard Request to use VUE_APP_AUTH_API_URL.
	 *
	 * @return {Array}
	 */
	static get inject() {
		return ['App/Http/AuthRequest']
	}
	/**
	 * Attempt to login a user via email and password.
	 *
	 * @param {String} email
	 * @param {String} password
	 * @return {Promise}
	 */
	login(email, password) {
		return this.request.post('v1/login', {
			email,
			password,
			auth_provider: 'cognito',
		})
	}

	refreshAccessToken(payload) {
		return this.request.post('v1/token', {
			...payload,
			grant_type: 'refresh',
		})
	}

	/**
	 * Make a new PersonalAccessTokens resource instance.
	 *
	 * @return {PersonalAccessTokens}
	 */
	personalAccessTokens() {
		return new PersonalAccessTokens(this.request)
	}
}
